import { useEffect } from 'react';

import { loadRecaptchaScript } from '../lib/recaptcha';

const INTERACTION_EVENTS = ['pointerdown', 'keydown', 'scroll', 'touchstart', 'focusin'] as const;

/**
 * Carga reCAPTCHA con la primera interacción, no al cargar la página: tener el
 * script presente cuesta ~1 MB (api.js lo baja tres veces: página, iframe y
 * verificador) aunque nadie use un formulario. Si alguien envía antes de
 * interactuar, `getRecaptchaClient` lo carga bajo demanda.
 */
export const useRecaptchaScript = (siteKey: string | undefined) => {
  useEffect(() => {
    if (!siteKey) return undefined;
    const load = () => loadRecaptchaScript(siteKey);
    INTERACTION_EVENTS.forEach((event) =>
      window.addEventListener(event, load, { once: true, passive: true }),
    );
    return () => INTERACTION_EVENTS.forEach((event) => window.removeEventListener(event, load));
  }, [siteKey]);
};
